import { useMutation } from '@tanstack/react-query';
import {
  BaseResponseEntity,
  ResendAccountActivationEmailDto,
  UserWalletManageService,
} from 'services/openapi';

export const useResendAccountActivationEmailMutation = () =>
  useMutation<BaseResponseEntity, Error, ResendAccountActivationEmailDto>({
    mutationFn: (variables) =>
      UserWalletManageService.userManageControllerResendAccountActivationEmail(
        variables,
      ),
  });
